export default __webpack_public_path__ + "static/media/photo--lg--90.2b64e437.jpg";